import Page from "constants/page";

type IPageLookup = Record<string, string>;

/**
 * Create an object to find the page name from their URLs.
 * @returns Dictionary from URL to page name.
 */
export const createPageLookup = () => {
    return Object.entries(Page).reduce<IPageLookup>((data, [page, url]) => ({ ...data, [url]: page }), {});
};

/**
 * From a URL find the name of the page (e.g. from "/main/anomalies" find "Anomalies").
 * @param pageLookup Dictionary from URL to page.
 * @param path       URL path.
 * @returns          Page name.
 */
export const getPageName = (path: string) => {
    const pageLookup = createPageLookup();

    const match = path.match(/(\/main\/[a-z-]+)/);

    if (match && match.length > 0) {
        return pageLookup[match[0]];
    }
};
